/**
 * v0.4.37 V3 — Predicate for the DUPLICATE-on-conflict UI.
 *
 * Given the full list of ingestion runs and the operator's current
 * selected-set of run ids, returns a function `(candidate) =>
 * boolean` that is TRUE iff including the candidate would cause a
 * file_hash collision with another already-selected run.
 *
 * Used by `CalculatePanel.renderRunRow`. Kept here so the parent
 * stays under the 400-LOC project cap.
 */
export function makeConflictPredicate(runs, selectedIds) {
  const selectedHashes = new Set();
  for (const r of (runs || [])) {
    if (selectedIds.includes(r.id) && r.file_hash) {
      selectedHashes.add(r.file_hash);
    }
  }
  return (candidate) => Boolean(
    candidate.file_hash
    && !selectedIds.includes(candidate.id)
    && selectedHashes.has(candidate.file_hash)
  );
}
